'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Bus-specific API calls
var BusService = exports.BusService = function () {
    function BusService(winresCloudService, $q) {
        _classCallCheck(this, BusService);

        this.winresCloudService = winresCloudService;
        this.$q = $q;
    }

    // getBusStops(searchCriteria) {
    //     return this.winresCloudService.makeAuthenticatedRequest(
    //         'GetBusStops',
    //         {
    //             'SearchCriteria': searchCriteria
    //         });
    // }

    _createClass(BusService, [{
        key: 'busStopsAutocomplete',
        value: function busStopsAutocomplete(name, depDestCode, depBeginDate, depEndDate, depDestIntClassSets) {
            return this.winresCloudService.makeAuthenticatedRequest('BusStopsAutocomplete', {
                'Name': name,
                'DepDestCode': depDestCode,
                'DepBeginDate': depBeginDate,
                'DepEndDate': depEndDate,
                "DepDestIntClassSets": depDestIntClassSets
            });
        }
    }]);

    return BusService;
}();

BusService.$inject = ['winresCloudService', '$q'];


//////////////////
// WEBPACK FOOTER
// ./src/winresCloud/busService.js
// module id = 569
// module chunks = 2